import React from 'react';
import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import SplitOne from "../elements/split/SplitOne";
import ServiceOne from "../elements/service/ServiceOne";
import Layout from "./layout/Layout";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import PricingFive from "../elements/pricing/PricingFive";
import SlipThree from "../elements/split/SlipThree";
import ServiceFour from "../elements/service/ServiceFour";


const CsmsDevelopment = () => {
    return (
        <>
            <SEO title="CSMS Development"/>
            <Layout>
                {/* Start Slider Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="content">
                                    <h3 className="title">Content Management System (CMS)</h3>
                                    <p className="mb--10">Enhance the functionality of your website with a custom-built CMS. Our expert developers specialize
                                        in utilizing cutting-edge technologies like Word Press and Joomla to create a
                                        seamless and efficient content management system. Take control of your website updates with ease.
                                        Enhance the functionality of your website with a custom-built CMS.
                                        Our expert developers specialize in utilizing cutting-edge technologies like Word Press and Joomla to
                                        create a seamless and efficient content management system. Take control of your website updates with ease.
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <img src="../images/ios/cms-01.png" alt="csms Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Slider Area  */}

                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign="text-center"
                                    radiusRounded=""
                                    subtitle=""
                                    title="Why Choose Us for CMS Development"
                                    description="Our team of skilled developers specialize in creating user-friendly
                                    CMS web applications that are technically advanced. Whether you need a custom-made
                                    CMS solution or modifications to popular platforms like WordPress or Joomla, we are
                                    equipped to meet your specific requirements with ease."/>
                            </div>
                        </div>
                        <ServiceFour
                            serviceStyle="service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign="text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}
                <Separator/>
                <CalltoActionThree/>
            </Layout>
        </>
    )
}
export default CsmsDevelopment;
